import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import LandingChrome from '../components/LandingChrome';
import { SOLUTION_FEATURE_ITEMS, USE_CASE_CARDS } from '../data/marketingData';
import './Landing.css';

const DOC_TITLE_EN = 'Features - ReplyTek AI WhatsApp Assistant';
const DOC_TITLE_ES = 'Funciones - ReplyTek, asistente de WhatsApp con IA';

export default function Features() {
  const { lang, t } = useLang();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = lang === 'en' ? DOC_TITLE_EN : DOC_TITLE_ES;
  }, [lang]);

  return (
    <LandingChrome>
      <main>
        <section className="section solution" style={{ paddingTop: '6rem' }}>
          <h1 className="section__title" style={{ marginBottom: '2rem' }}>
            {lang === 'en'
              ? 'Features - ReplyTek AI WhatsApp Assistant'
              : 'Funciones - ReplyTek, asistente de WhatsApp con IA'}
          </h1>
          <div className="solution__features">
            {SOLUTION_FEATURE_ITEMS.map((f, i) => (
              <div className="solution__item" key={i}>
                <span className="solution__icon">{f.icon}</span>
                <span>{f.text[lang]}</span>
              </div>
            ))}
          </div>
        </section>

        <section className="section use-cases">
          <h2 className="section__title">
            {lang === 'en' ? 'Built for your business' : 'Hecho para tu negocio'}
          </h2>
          <div className="cards-4">
            {USE_CASE_CARDS.map((c, i) => (
              <div className="use-card usecase-card" key={i}>
                <div className="use-card__icon">{c.icon}</div>
                <h3>{c.title[lang]}</h3>
                <p>{c.desc[lang]}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="section cta-final cta-section">
          <h2>
            {lang === 'en'
              ? 'Ready to automate WhatsApp for your business?'
              : '¿Listo para automatizar WhatsApp en tu negocio?'}
          </h2>
          <button type="button" className="btn-primary btn-lg" onClick={() => navigate('/signup')}>
            {t('get_started')}
          </button>
        </section>
      </main>
    </LandingChrome>
  );
}
